import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Nowe zamówienie {{method}}!',
        scheduled: 'Zaplanowane zamówienie {{method}}!',
        on_site: 'Nowe zamówienie do stolika!',
        // Table orders are ASAP; this is for room-service orders scheduled before the rename.
        on_site_scheduled: 'Zaplanowane zamówienie do stolika!',
      },
      labels: {
        today: 'dzisiaj',
        time_remaining_to_accept: 'pozostało na akceptację',
      },
      time_tag: {
        [OrderMethod.Pickup]: {
          asap: '🕓 Odbiór za {{time}}',
          scheduled: '🕓 Odbiór {{day}} o {{time}}',
          scheduled_today: '🕓 Odbiór dzisiaj o {{time}}',
        },
        [OrderMethod.Delivery]: {
          asap: '🕓 Dostawa za {{time}}',
          scheduled: '🕓 Dostawa {{day}} o {{time}}',
          scheduled_today: '🕓 Dostawa dzisiaj o {{time}}',
        },
        [OrderMethod.OnSite]: {
          // No 🕓: the screen draws the design's clock icon for table orders.
          asap: 'Podanie za {{from}}–{{to}} min',
          scheduled: 'Podanie {{day}} o {{time}}',
          scheduled_today: 'Podanie dzisiaj o {{time}}',
        },
      },
      time_tag_estimated: {
        asap: '🕓 Szacowany czas odbioru: {{time}}',
        scheduled: '🕓 Szacowany czas odbioru: {{day}} o {{time}}',
      },
      buttons: {
        confirm_order: 'Potwierdź zamówienie',
        cancel_order: 'Anuluj zamówienie',
      },
      feedback: {
        rough_estimate_warning:
          'To tylko przybliżony szacunek. Rzeczywisty czas przygotowania otrzymasz po przydzieleniu kierowcy i potwierdzeniu czasu dostawy. W tym momencie bilet zostanie wydrukowany automatycznie.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Czas przygotowania',
      labels: {
        today: 'dzisiaj',
        order_time: {
          [OrderMethod.Delivery]: {
            asap: 'Dostawa za',
            scheduled: 'Dostawa w dniu',
            scheduled_today: 'Dostawa',
          },
          [OrderMethod.Pickup]: {
            asap: 'Odbiór za',
            scheduled: 'Odbiór w dniu',
            scheduled_today: 'Odbiór',
          },
          [OrderMethod.OnSite]: {
            asap: 'Podanie za',
            scheduled: 'Podanie dnia',
            scheduled_today: 'Podanie',
          },
        },
        can_you_make_it: 'Czy dasz radę?',
        we_also_send_this_update_to_the_customer: 'Wysyłamy tę aktualizację również do klienta',
      },
      buttons: {
        yes_lets_go: 'Tak, do dzieła!',
        no_change_time: 'Nie, zmień czas',
        confirm: 'Potwierdź',
      },
      toasts: {
        order_confirmed: {
          title: 'Zamówienie #{{number}} potwierdzone',
          body: 'Jeszcze nie przygotowuj! Powiadomimy Cię, gdy zostanie przydzielony kierowca.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Niestety dostawa musi zostać anulowana, ponieważ kierowca nie jest dostępny. Kliknij trzy kropki w prawym górnym rogu, aby anulować zamówienie i zwrócić pieniądze klientowi.',
        [BackendErrorCode.DeliveryProviderException]:
          'Niestety dostawa musi zostać anulowana, ponieważ kierowca nie jest dostępny. Kliknij trzy kropki w prawym górnym rogu, aby anulować zamówienie i zwrócić pieniądze klientowi.',
        [BackendErrorCode.DeliveryDispatchRetrying]:
          'Zamówienie przyjęte, ale nie zarezerwowano jeszcze kierowcy. Próbujemy przez 15 minut i powiadomimy Cię, jeśli nikt się nie znajdzie.',
      },
    },
  },
  error_messages: {
    something_went_wrong: 'Coś poszło nie tak, spróbuj ponownie',
  },
};
